var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm.1 12.085c.07.037.153.037.223 0 .138-.1.264-.217.375-.347.16-.19.3-.397.459-.612l.222.135c-.32.534-.65 1.03-1.139 1.401a1.768 1.768 0 0 1-.893.373c-.763.086-1.251-.434-1.069-1.182.16-.658.364-1.306.55-1.959.185-.652.372-1.33.56-1.993.016-.066.027-.132.034-.199a.392.392 0 0 0-.353-.49A3.4 3.4 0 0 0 6.72 7.2a.567.567 0 0 1 .018-.114l.022-.16 2.758-.441-.192.668-.043.16-1.205 4.207c-.04.11-.067.225-.078.342 0 .085.036.166.1.223zm.662-7.125a.996.996 0 0 1-.99-1.005.993.993 0 1 1 1.988 0 1.007 1.007 0 0 1-.998 1.005z",
    fill: "#8D99AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.41ea2bc1beff29720717ecd09e955f24.svg";
export { ForwardRef as ReactComponent };